import { useLayoutEffect, useState } from 'react';

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

export function useCursorTooltipPosition({ open, popupRef, cursor }) {
  const [pos, setPos] = useState({
    left: 0,
    top: 0,
  });

  useLayoutEffect(() => {
    if (!open) return;
    const popup = popupRef.current;
    if (!popup) return;

    const viewportW = window.innerWidth;
    const viewportH = window.innerHeight;
    const gutter = 8;
    const gap = 10;

    const update = () => {
      const p = popup.getBoundingClientRect();
      const left = clamp(
        cursor.x - p.width / 2,
        gutter,
        Math.max(gutter, viewportW - p.width - gutter),
      );

      const desiredTop = cursor.y - p.height - gap;
      const top =
        desiredTop >= gutter
          ? desiredTop
          : clamp(cursor.y + gap, gutter, Math.max(gutter, viewportH - p.height - gutter));

      setPos({ left, top });
    };

    update();
    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, true);

    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('scroll', update, true);
    };
  }, [cursor.x, cursor.y, open, popupRef]);

  return pos;
}
